<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-view-dashboard
                </v-icon>
                Tableau de bord Happy Quest
                <v-icon right>
                  mdi-view-dashboard
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-bold">
              Connexion
            </div>

            <!-- Formulaire -->
            <v-form
              v-if="!isLoading"
              v-model="isValid"
              @keyup.native.enter="handleFormSubmit"
            >
              <v-text-field
                v-model="email"
                color="secondary"
                label="Email..."
                :rules="[rules.required, rules.email]"
                hide-details="auto"
                hint="example@happyquest.fr"
                prepend-icon="mdi-at"
                required
              />

              <v-text-field
                v-model="password"
                class="mb-8"
                color="secondary"
                label="Mot de passe..."
                :rules="[rules.required, rules.minLength]"
                type="password"
                prepend-icon="mdi-lock"
                required
              />

              <p
                v-if="error.hasError"
                class="title text-uppercase error--text"
              >
                {{ error.errorMsg }}
              </p>

              <div class="my-2">
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  :disabled="!isValid"
                  @click="handleFormSubmit"
                >
                  Se connecter
                  <v-icon right>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-form>
            <v-row
              v-else
              justify="center"
            >
              <circle10 />
            </v-row>

            <!-- Bouton d'accès au formulaire d'inscription
            <v-btn
              class="ma-2"
              text
              color="primary"
              @click="handleRegister"
            >
              S'inscrire
            </v-btn>
          -->
            <v-btn
              class="ma-2"
              text
              color="primary"
              @click="handleForgottenPwd"
            >
              Mot de passe oublié ?
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>

    <!-- Affichage des messages -->
    <v-snackbar
      v-model="snackMsgIsDisplayed"
      color="secondary"
      :timeout="5000"
      :value="true"
      absolute
      shaped
      top
    >
      {{ snackMsg }}
    </v-snackbar>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'Login',

    /* Sous-composants utilisés par ce composant */
    components: {
      Circle10,
    },

    /* Paramètres */
    props: {
      displaySnackMsg: {
        type: Boolean,
        default: false,
      },
      snackMsg: {
        type: String,
        default: '',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        email: '',
        password: '',
        isLoading: false,
        isValid: false,
        snackMsgIsDisplayed: this.displaySnackMsg,
        error: {
          hasError: false,
          errorMsg: '',
        },
        rules: {
          minLength: value => (value.length >= 4) || 'Le mot de passe contient 4 caractères minimum.',
          required: value => !!value || 'Ce champ ne peut être vide.',
          email: value => {
            const pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
            return pattern.test(value) || 'Email invalide.'
          },
        },
      }
    },

    /* Fonctions internes */
    methods: {
      // Login
      handleFormSubmit: function () {
        if (this.isValid) {
          this.isLoading = true
          this.$Auth.login(this.email, this.password)
            .then(res => {
              this.$router.push({ name: 'Dashboard', params: { displayWelcomeMsg: true } })
            })
            .catch(err => {
              this.error.hasError = true
              this.error.errorMsg = err.response.data
              this.password = ''
            }).finally(() => {
              this.isLoading = false
            })
        }
      },

      // Route vers formulaire d'inscription
      handleRegister: function () {
        this.$router.push({ name: 'Register' })
      },

      // Route vers formulaire de mot de passe oublié
      handleForgottenPwd: function () {
        this.$router.push({ name: 'Forgotten Password' })
      },
    },
  }
</script>
